import firebase from "firebase/app";
import "firebase/firestore";
import 'firebase/auth';
import 'firebase/storage';

var config = {
    apiKey: process.env.VUE_APP_FIREBASE_API_KEY,
    authDomain: process.env.VUE_APP_FIREBASE_AUTH_DOMAIN,
    projectId: process.env.VUE_APP_FIREBASE_PROJECT_ID
};
firebase.initializeApp(config);

var db = firebase.firestore();
var auth = firebase.auth();
var storage = firebase.storage();

export {
    db,
    auth,
    storage
}